import React from 'react';

import Button, { ButtonProps } from '@mui/material/Button';

type Props = Omit<ButtonProps, 'startIcon' | 'variant'> & {
  icon: React.ReactNode;
  children: React.ReactNode;
  onClick?: () => void;
};

const LowProfileButton: React.FC<Props> = ({ icon, children, onClick, ...rest }) => {
  return (
    <Button
      {...rest}
      variant="text"
      startIcon={icon}
      onClick={onClick}
      sx={{
        textTransform: 'none',
        padding: '4px 8px',
        minWidth: 'auto',
        gap: 2,
        '& .MuiButton-startIcon': { marginRight: 0 },
        '&:hover': {
          backgroundColor: theme => theme.palette.action.hover,
        },
      }}
    >
      {children}
    </Button>
  );
};

export default LowProfileButton;
